<template>
  <a-modal
    v-model="visible"
    title="变更销售"
    @ok="handleOk"
    @cancel="handleClose"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
  >
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="销售选择" prop="user_id">
        <a-select
          v-model="form.user_id"
          style="width: 100%"
          placeholder="请选择"
          option-label-prop="label"
          :filter-option="filterOption"
        >
          <a-select-option
            v-for="v in userList"
            :key="v.user_id"
            :value="v.user_id"
            :label="v.real_name"
            :disabled="v.user_id == whoManagerId"
          >
            {{ v.real_name }}
            <span
              role="img"
              :aria-label="v.real_name"
              style="font-size: 14px; color: #888"
            >
              ({{ v.department.department_name }})
            </span>
          </a-select-option>
        </a-select>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>
  <script>
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      customerShareList: [],
      form: {
        customer_id: "",
        user_id: undefined,
      },
      whoManagerId: "",
      rules: {
        user_id: {
          required: true,
          message: "请选择销售",
          trigger: "change",
        },
      },
      userList: [],
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };
  },
  methods: {
    init(customer_id, whoManagerId) {
      this.form.customer_id = customer_id;
      this.whoManagerId = whoManagerId;
      this.visible = true;
      this.getUserList();
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    getUserList() {
      this.$http({
        url: "/admin/user/page?page=1&limit=200",
        method: "get",
      }).then((res) => {
        this.userList = res.data.result;
      });
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          this.$http({
            url: "/admin/customer/changemanager",
            method: "post",
            data: this.form,
          })
            .then(() => {
              this.$message.success("变更成功");
              this.handleClose();
              this.$emit("ok");
            })
            .finally(() => (this.confirmLoading = false));
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleClose() {
      this.$refs.ruleForm.resetFields();
      this.visible = false;
    },
  },
};
</script>
  
  <style>
</style>